require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/dimmer.css');
require('./section2.styl');

import React from 'react';

import Lightbox from 'react-image-lightbox';

import Image2 from './imgs/2.jpg';

const dataSource = require('json!../main/data/daten_alltext.json');

class Section2 extends React.Component {

    constructor(props) {
        super(props);

        this.state = ({
          isOpen: false,
          mietPreis: 0,
          steuerEinkommen: 0,
          steuernMarriedP75: 0,
          steuernUnmarriedP75: 0,
          steuernMarriedP25: 0,
          steuernUnmarriedP25: 0
        })

    }

    niceNumber(value, sep) {
        if (sep == null) {
          sep = '\'';
        }

        value = Math.round(value);

        value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);

        return value;
      };

    componentWillReceiveProps(props) {
      if(this.props.quarter != '') {

        // Calculate data when new props arrive

        for(let i=0; i<dataSource.length; i++) {

          // console.log(dataSource[i])

          if(dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2016 && dataSource[i].SteuerTariflang == 'NA') {
            this.setState({
              mietPreis: dataSource[i].Mietpreis
            })
          }

          if(dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2014 && dataSource[i].SteuerTariflang == 'Verheiratet') {
            // console.log(dataSource[i])
            this.setState({
              steuerEinkommen: this.niceNumber(dataSource[i].SteuerEinkommen_Median * 1000)
            })
          }

          if(dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2014 && dataSource[i].SteuerTariflang == 'Verheiratet') {
            // console.log(dataSource[i])
            this.setState({
              steuernMarriedP75: this.niceNumber(dataSource[i].SteuerEinkommen_P75 * 1000),
              steuernMarriedP25: this.niceNumber(dataSource[i].SteuerEinkommen_P25 * 1000)
            })
          }

          if(dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2014 && dataSource[i].SteuerTariflang == 'Grundtarif') {
            // console.log(dataSource[i])
            this.setState({
              steuernUnmarriedP75: this.niceNumber(dataSource[i].SteuerEinkommen_P75 * 1000),
              steuernUnmarriedP25: this.niceNumber(dataSource[i].SteuerEinkommen_P25 * 1000)
            })
          }

          // console.log(this.state.steuerEinkommen)



        }

      }
    }


  render() {

        return (

            <div className='section two wrapper'>

                <div className={`ui  dimmable ${this.props.readerMadeHisChoice ? '' : 'dimmed'} segment padded`}>
                    <div className='ui inverted simple dimmer'></div>

                        <p className='section-text'>
                          <strong>Ist Zürich eine gute Stadt, um arm zu sein?</strong> «Ja und nein», sagt Oliver. Beide Antworten hätten mit dem Reichtum der Stadt zu tun: «Weil die Menschen so viel besitzen, tröpfelt auch etwas davon zu mir herunter.» So hat er schon öfters alte Hosen von Freunden geschenkt bekommen, weil er kein Geld hatte, um seine zerrissenen zu ersetzen.
                        </p>

                            <p className='section-text'>Auf der anderen Seite hat das Leben in der Stadt seinen Preis. Die Krankenkassenprämien sind höher als in anderen Orten im Kanton, die Betreuungskosten für Kinder sind teuer und die Mieten sind in den letzten zehn Jahren deutlich angestiegen. Die Immobilienberatungsfirma Wüest Partner schätzt, dass die Angebotsmieten seit 2006 um rund 36,5 Prozent gestiegen sind – für eine durchschnittliche 4-Zimmer-Wohnung mit 110 Quadratmetern.
                              { this.props.quarter != undefined && this.props.readerIsCityCitizen == true &&                              <span className={`personalised text`}>Im Stadtkreis, in dem Sie wohnen, beträgt die mittlere Miete einer solchen Wohnung {this.state.mietPreis} Franken.</span>
                              }
                              &nbsp;Mit den steigenden Mieten verbinden <a href='http://staedteinitiative.ch/cmsfiles/staedteinitiative_sozialpolitik_bericht_2015.pdf' target='_blank'>Experten auch den Rückgang</a> der Sozialhilfequote in Zürich. Weil günstiger Wohnraum rarer wurde, sind viele Sozialhilfebeziehende oder armutsgefährdete Menschen in Agglomerationsgemeinden oder aufs Land gezogen.
                            </p>

                  { this.state.isOpen &&
                    <Lightbox
                      mainSrc={Image2}
                      imageCaption='Abgewetzt: Weil sich Oliver keine neuen Kleider leisten kann, hat er von Bekannten alte geschenkt bekommen.'
                      onCloseRequest={() => this.setState({isOpen: false})}
                    />
                  }

  <div className='section text image wrapper'>

      <img
        src={Image2} width='100%'
        onClick={() => this.setState({ isOpen: true })}
      />

    <p className='bild legend'>Abgewetzt: Weil sich Oliver keine neuen Kleider leisten kann, hat er von Bekannten alte geschenkt bekommen.</p>
  </div>
                            <p className='section-text'>
                              Oliver konnte in seiner Wohnung bleiben. Aber: Essen, Kaffee, Kino, Konzerte, Kultur – alles kostet mehr als an anderen Orten. <strong>Das Sozialleben leidet unter der Armut.</strong> Mit sinkendem Kontostand sind auch die Freunde weniger geworden. Die Freunde gehen lieber aus, als Oliver in seiner Wohnung zu besuchen. Er versteht das, weil er auch lieber ausgehen würde, aber das Geld dazu fehlt.                            </p>

                            <p className='section-text'>
                              Die Steuerdaten der Stadt Zürich zeigen, wie gut die Zürcherinnen und Zürcher (<a href='https://www.stadt-zuerich.ch/fd/de/index/steuern/quellensteuer/auslaendische_arbeitnehmer.html' target='_blank'>ohne Quellenbesteuerte</a>) verdienen. Sie zeigen aber ebenfalls, <strong>dass nicht alle Einkommen in den letzten rund 15 Jahren gleich stark gestiegen sind.</strong> Das mittlere steuerbare Einkommen hat in der Stadt um etwas mehr als 20 Prozent zugenommen – bei Ledigen und Verheirateten. Die Hälfte versteuert mehr, die Hälfte weniger. Bei den Ledigen ist es zwischen 1999 und 2014 von 34'500 Franken auf 42'200, bei den Ehepaaren von 63'100 auf 76'500 Franken gestiegen. Diese Zahlen mögen tief erscheinen, weil sie ausblenden, dass das steuerbare Einkommen deutlich unter dem Bruttoeinkommen liegt. Ein Beispiel vom <a href='https://www.vermoegenszentrum.ch/ratgeber/wissensbeitrage/privatkunden/steuern-sparen/berechnung-des-steuerbaren-einkommens.html' target='_blank'>Vermögenszentrum</a>: Ein Ehepaar mit zwei Kindern lebt in einer Mietwohnung im Kanton Zürich. Es verdient brutto 100'000 Franken im Jahr. Nach allen Abzügen liegt das steuerbare Einkommen über 40 Prozent unter dem Bruttoeinkommen, bei rund 57'700 Franken, also unter dem mittleren Zürcher Wert.
                              { this.props.quarter != undefined && this.props.readerIsCityCitizen == true &&
                              <span
                                className={`personalised text`}>Zum Vergleich: Im Quartier {this.props.quarter} beträgt das mittlere Einkommen der Ehepaare {this.state.steuerEinkommen} Franken.</span>
                              }
                            </p>

                            <p className='section-text'>
                              Noch stärker angestiegen ist das steuerbare Einkommen der Reichen. Wenn Verheiratete im Jahr 1999 89'500 Franken oder mehr versteuerten, gehörten sie zu den reichsten 25 Prozent der Zürcherinnen und Zürcher. Bei den Ledigen lag die Grenze bei 53'300 Franken. 2014 gehörte zu den reichsten 25 Prozent, wer als Ehepaar mindestens 119'000 Franken und als Einzelperson mindestens 66'000 Franken versteuerte: Das entspricht einer Zunahme von knapp 33 respektive rund 23 Prozent.
                              { this.props.quarter != undefined && this.props.readerIsCityCitizen == true &&                              <span
                                className={`personalised text`}>In der Nachbarschaft, in der Sie wohnen, versteuerten die reichsten 25 Prozent der Ehepaare mindestens {this.state.steuernMarriedP75} Franken und der Ledigen {this.state.steuernUnmarriedP75} Franken.</span>
                              }
                            </p>

                            <p className='section-text'>
                              <strong>Und bei den ärmsten 25 Prozent?</strong> Auch dort stieg das steuerbare Einkommen an, aber deutlich weniger: Der Grenzwert stieg von maximal 17'600 Franken auf 19'600 (rund 11 Prozent mehr) bei den Unverheirateten und von maximal 44'200 auf 48'800 (rund 10 Prozent) bei den Ehepaaren.

                              { this.props.quarter != undefined && this.props.readerIsCityCitizen == true &&                              <span
                                className={`personalised text`}>Im Quartier, in dem Sie leben, versteuerten die ärmsten 25 Prozent der Ledigen maximal {this.state.steuernUnmarriedP25} Franken und der Verheirateten {this.state.steuernMarriedP25} Franken.</span>
                              }

                            </p>
                </div>

            </div>
        );
    }
}

Section2.defaultProps = {};

Section2.propTypes = {
    readerIsCityCitizen: React.PropTypes.bool,
    readerMadeHisChoice: React.PropTypes.bool,
    quarter: React.PropTypes.string,
    circle: React.PropTypes.string
};

export default Section2;



// WEBPACK FOOTER //
// ./src/components/section2/Section2.js